import { equal, notEqual } from './equality';

export const operators = {
  '=': equal,
  '!=': notEqual,
};
